<!--
  ~ Copyright (c) 1999 - 2019 Accorto, Inc. - All rights reserved.
  -->

<div class="slds-form-element slds-form-element_horizontal slds-m-top_small">
  <label class="slds-form-element__label" for="select-input">Search</label>
  <div class="slds-form-element__control slds-input-has-fixed-addon">
    <input (keyup)="onKeyUp($event)" class="slds-input" id="select-input"/>
    <span class="slds-form-element__addon">{{summary}}</span>
  </div>
</div>

<div style="max-height: 400px">
  <div class="slds-scrollable_y">
    <table class="slds-table">
      <tbody>
      <tr *ngFor="let record of records"
          [style.display]="record.isSelected ? 'table-row' : 'none'"
          class="slds-hint-parent">
        <td><input (click)="onClick(record)" type="checkbox"></td>
        <td (click)="onClick(record)"
            *ngFor="let cn of columnNames">
          <a>{{getValue(record, cn)}}</a>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</div>

